import { CASDispositionTypes } from '../../../cimsPage/instances/cas'
import { DispositionTypes } from '../../common'

const { Create, Edit, RemoveRestore, View } = DispositionTypes({
  create: '74FFB49E-F68B-4BD7-98CB-6C5BFBCEFC41',
  edit: '98D64998-A629-4512-86AB-E9CD21397F75',
  view: 'E9AFA11E-ABCC-4D37-8700-A84490B86996',
  removeRestore: '6A8F2CA1-6903-4461-B27E-CBCB761E060B',
  page: CASDispositionTypes,
})

export const CreateCASDispositionType = Create
export const EditCASDispositionType = Edit
export const RemoveRestoreCASDispositionType = RemoveRestore
export const ViewCASDispositionType = View

export type CASDispositionTypePermission =
  | typeof CreateCASDispositionType
  | typeof EditCASDispositionType
  | typeof RemoveRestoreCASDispositionType
  | typeof ViewCASDispositionType
